export type PostStatus = 'draft' | 'published' | 'archived';

export const POST_STATUS_LABELS: Record<PostStatus, string> = {
  draft: 'Draft',
  published: 'Published',
  archived: 'Archived',
};

export const POST_STATUS_LABELS_ZH: Record<PostStatus, string> = {
  draft: '草稿',
  published: '已發布',
  archived: '已歸檔',
};

export const POST_STATUS_COLORS: Record<PostStatus, string> = {
  draft: 'bg-yellow-100 text-yellow-800',
  published: 'bg-green-100 text-green-800',
  archived: 'bg-gray-100 text-gray-800',
};

export const BLOG_CATEGORIES = [
  { value: 'news', label: 'News', labelZh: '新聞' },
  { value: 'tech', label: 'Technology', labelZh: '技術' },
  { value: 'case-study', label: 'Case Study', labelZh: '案例研究' },
  { value: 'announcement', label: 'Announcement', labelZh: '公告' },
] as const;

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  title_zh: string;
  summary: string;
  summary_zh: string;
  doc_id: string;
  doc_id_zh: string;
  cover_image: string;
  category: string;
  tags: string[];
  status: PostStatus;
  author: string;
  published_at?: string;
  created_at: string;
  updated_at: string;
}

export interface BlogPostWithContent extends BlogPost {
  content: string;
  content_zh: string;
}

export interface CreatePostRequest {
  slug?: string;
  title: string;
  title_zh?: string;
  summary: string;
  summary_zh?: string;
  doc_id: string;
  doc_id_zh?: string;
  cover_image?: string;
  category: string;
  tags?: string;
  author?: string;
}

export interface UpdatePostRequest {
  slug?: string;
  title?: string;
  title_zh?: string;
  summary?: string;
  summary_zh?: string;
  doc_id?: string;
  doc_id_zh?: string;
  cover_image?: string;
  category?: string;
  tags?: string;
  author?: string;
}

export interface PostFilter {
  status?: PostStatus;
  category?: string;
  limit?: number;
  offset?: number;
}

export interface PostListResponse {
  posts: BlogPost[];
  total: number;
  limit: number;
  offset: number;
}
